import { render, staticRenderFns } from "./LegalLinks.vue?vue&type=template&id=784040f2&scoped=true"
import script from "./LegalLinks.vue?vue&type=script&lang=js"
export * from "./LegalLinks.vue?vue&type=script&lang=js"
import style0 from "./LegalLinks.vue?vue&type=style&index=0&id=784040f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784040f2",
  null
  
)

export default component.exports